import React from 'react';
import { Link } from 'react-router-dom';
import { asset } from '../utils/asset';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import SingleDatePicker from '../components/SingleDatePicker';

const Calendar: React.FC = () => {
    /* calendar view */
    const currentday = new Date();
    const thismonth = ("0" + (currentday.getMonth() + 1)).slice(-2);
    const thisyear = currentday.getFullYear();
    const thisday = ("0" + currentday.getDate()).slice(-2);

    const events = [
        {
            title: 'All Day Event',
            className: 'bg-success-subtle',
            start: thisyear + '-' + thismonth + '-01',
            description: 'Lecture'
        },
        {
            title: 'Long Event',
            className: 'bg-success-subtle',
            start: thisyear + '-' + thismonth + '-07',
            end: thisyear + '-' + thismonth + '-10'
        },
        {
            groupId: '999',
            className: 'bg-theme-1-space text-white',
            title: `<span class="position-absolute top-0 end-0 badge bg-success p-1 m-1"><small>Paid</small></span ><p class="mb-0 small fw-medium">16:00 am</p><div class="row gx-2"><div  class="col-auto"><img src="${asset('assets/img/adminuiux/user-4.jpg')}" class="avatar avatar-20 rounded-circle" alt=""/> <img src="https://i.pravatar.cc/300" class="avatar avatar-20 rounded-circle" alt=""/></div> <div class="col">Will Johnson</div></div><p class="mb-0 opacity-75 small text-truncated" >Investment Module understanding</p>`,
            start: thisyear + '-' + thismonth + '-09T16:00:00'
        },
        {
            groupId: '999',
            title: 'Repeating Event',
            className: 'bg-cyan-subtle',
            start: thisyear + '-' + thismonth + '-16T16:00:00'
        },
        {
            title: '<p class="mb-0 small fw-medium">09:00 am - 12:00 pm </p><div class="row gx-2"><div  class="col-auto"><i class="bi bi-microsoft-teams"></i></div><div class="col">Evolution of era</div></div><p class="mb-0 opacity-75 small text-truncated" >Conference</p>',
            className: 'bg-yellow-subtle',
            start: thisyear + '-' + thismonth + '-11',
            end: thisyear + '-' + thismonth + '-13'
        },
        {
            title: 'Meeting',
            className: 'bg-orange-subtle',
            start: thisyear + '-' + thismonth + '-12T10:30:00',
            end: thisyear + '-' + thismonth + '-10T12:30:00'
        },
        {
            title: 'Lunch',
            className: 'bg-purple-subtle',
            start: thisyear + '-' + thismonth + '-' + thisday + 'T04:00:00'
        },
        {
            title: '<p class="mb-0 small fw-medium">10:30 am, 2hr</p><div class="row gx-2"><div  class="col-auto"><i class="bi bi-buildings"></i></div><div class="col">Evolution of era</div></div><p class="mb-0 opacity-75 small text-truncated" >Meeting</p>',
            className: 'bg-orange-subtle',
            start: thisyear + '-' + thismonth + '-' + thisday + 'T10:30:00'
        },
        {
            title: 'Happy Hour',
            className: 'bg-green-subtle',
            start: thisyear + '-' + thismonth + '-' + thisday + 'T12:30:00'
        },
        {
            title: `<p class="mb-0 small fw-medium">16:00 am</p><div class="row gx-2"><div  class="col-auto"><img src="${asset('assets/img/adminuiux/user-6.jpg')}" class="avatar avatar-20 rounded-circle" alt=""/> </div> <div class="col">Will Johnson</div></div><p class="mb-0 opacity-75 small text-truncated" >Investment Module understanding</p>`,
            className: 'bg-info-subtle',
            start: thisyear + '-' + thismonth + '-10T20:00:00'
        },
        {
            title: `<span class="position-absolute top-0 end-0 badge bg-danger p-1 m-1"><small>Unpaid</small></span ><p class="mb-0 small fw-medium">7:00 am</p><div class="row gx-2"><div  class="col-auto"><img src="${asset('assets/img/adminuiux/user-7.jpg')}" class="avatar avatar-20 rounded-circle" alt=""/> </div> <div class="col">Rickie Birthday</div></div><p class="mb-0 opacity-75 small text-truncated" >Birthday Celebration</p>`,
            className: 'bg-theme-1-space text-white',
            start: thisyear + '-' + thismonth + '-' + thisday + 'T07:00:00'
        },
        {
            title: 'Click for Google',
            className: 'bg-primary-subtle',
            url: 'http://google.com/',
            start: thisyear + '-' + thismonth + '-28'
        }
    ];
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Calendar</h6>
                        <p className="text-secondary small">Book and Manage Appointments</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Calendar</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                {/* full calendar view */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-12 col-xl">
                        {/* Calendar Third party */}
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <FullCalendar
                                    plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
                                    initialView="timeGridDay"
                                    height="auto"
                                    headerToolbar={{
                                        left: 'prev,next today',
                                        center: 'title',
                                        right: 'dayGridMonth,timeGridWeek,timeGridDay'
                                    }}
                                    events={events as any}
                                    eventContent={(info) => {
                                        return <div dangerouslySetInnerHTML={{ __html: info.event.title }} />;
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {/* book appointment and summary */}
                    <div className="col-12 col-md-12 col-xl-3 ">
                        <h6 className="mb-3">Book an appointment</h6>
                        <div className="dropdown w-100 mb-4">
                            <button className="btn btn-link dropdown-toggle text-start no-caret w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="row align-items-center gx-3">
                                    <span className="col-auto">
                                        <span className="avatar avatar-40 rounded-circle coverimg">
                                            <img src={asset('assets/img/adminuiux/user-4.jpg')} alt="" />
                                        </span>
                                    </span>
                                    <span className="col">
                                        <span className="mb-1 h6 d-block">Mr. Ryan Sylia</span>
                                        <span className="opacity-75 small d-block">Fund Manager</span>
                                    </span>
                                    <span className="col-auto">
                                        <i className="bi bi-chevron-down small"></i>
                                    </span>
                                </span>
                            </button>
                            <ul className="dropdown-menu w-100">
                                <li>
                                    <a className="dropdown-item active" >
                                        <div className="row align-items-center gx-3">
                                            <div className="col-auto">
                                                <figure className="avatar avatar-40 rounded-circle coverimg">
                                                    <img src={asset('assets/img/adminuiux/user-4.jpg')} alt="" />
                                                </figure>
                                            </div>
                                            <div className="col">
                                                <p className="mb-1">Mr. Ryan Sylia</p>
                                                <p className="opacity-75 small">Fund Manager</p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" >
                                        <div className="row align-items-center gx-3">
                                            <div className="col-auto">
                                                <figure className="avatar avatar-40 rounded-circle coverimg">
                                                    <img src={asset('assets/img/adminuiux/user-5.jpg')} alt="" />
                                                </figure>
                                            </div>
                                            <div className="col">
                                                <p className="mb-1">Ms. Angelina</p>
                                                <p className="opacity-75 small">Finance Specialist</p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item">
                                        <div className="row align-items-center gx-3">
                                            <div className="col-auto">
                                                <figure className="avatar avatar-40 rounded-circle coverimg">
                                                    <img src={asset('assets/img/adminuiux/user-7.jpg')} alt="" />
                                                </figure>
                                            </div>
                                            <div className="col">
                                                <p className="mb-1">Mrs. Smriti Vandana</p>
                                                <p className="opacity-75 small">General Expert</p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="row gx-3">
                            {/* inline calendar */}
                            <div className="col-12 col-sm-6 col-xl-12 mb-4">
                                <h6 className="mb-3">Select Date</h6>
                                <SingleDatePicker inline={true} />
                            </div>
                            {/* appointment timings */}
                            <div className="col-12 col-sm-6 col-xl-12 mb-4">
                                <h6 className="mb-3">Select Time</h6>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1 active">
                                    <span>11:00 AM</span>
                                </button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>11:30 AM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>12:00 PM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>12:30 PM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>1:00 PM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>1:30 PM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>2:00 PM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>2:30 PM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>3:00 PM</span></button>
                                <button className="btn btn-sm btn-outline-theme mb-2 me-1"><span>3:30 PM</span></button>
                                <br /><br />
                                {/* create button */}
                                <button className="btn btn-theme w-100">
                                    <i className="bi bi-plus"></i> <span>Create</span>
                                </button>
                            </div>
                            {/* Total patients */}
                            <div className="col-6 col-sm-3 col-lg-3 col-xl-6 mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="avatar avatar-60 text-center rounded bg-success-subtle text-success-emphasis mb-3">
                                            <i className="bi bi-calendar-event h5"></i>
                                        </div>
                                        <h4 className="mb-0">1320</h4>
                                        <p className="text-secondary small">Meetings</p>
                                    </div>
                                </div>
                            </div>
                            {/* Total Staff */}
                            <div className="col-6 col-sm-3 col-lg-3 col-xl-6 mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="avatar avatar-60 text-center rounded bg-info-subtle text-info-emphasis mb-3">
                                            <i className="bi bi-bank h5"></i>
                                        </div>
                                        <h4 className="mb-0">20</h4>
                                        <p className="text-secondary small">Funds</p>
                                    </div>
                                </div>
                            </div>
                            {/* Total Rooms occupied */}
                            <div className="col-6 col-sm-3 col-lg-3 col-xl-6 mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="avatar avatar-60 text-center rounded bg-warning-subtle text-warning-emphasis mb-3">
                                            <i className="bi bi-people h5"></i>
                                        </div>
                                        <h4 className="mb-0">1320</h4>
                                        <p className="text-secondary small">Clients</p>
                                    </div>
                                </div>
                            </div>
                            {/* Total online appointment */}
                            <div className="col-6 col-sm-3 col-lg-3 col-xl-6 mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="avatar avatar-60 text-center rounded bg-danger-subtle text-danger-emphasis mb-3">
                                            <i className="bi bi-building h5"></i>
                                        </div>
                                        <h4 className="mb-0">820</h4>
                                        <p className="text-secondary small">Partners</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Calendar;
